module.exports = __webpack_public_path__ + "img/Schema_of_Optimize_Seating_Capacity.e069668b.svg";